'use client'

import type { ReactNode } from 'react'

import { useInspirationalProvider } from '../../context/InspirationalProvider/useInspirationalProvider'

type Props = {
	readonly index: number
	readonly children: ReactNode
}

export const ModuleVisibilityGuard = ({ index, children }: Props) => {
	const { nVisibleModules } = useInspirationalProvider()
	if (index < nVisibleModules) {
		return children
	}
	return null
}
